import { h, resolveComponent } from 'vue'

const PrincipalSaldo = () => import('@/app/views/publica/views/Principal');
const Consentimiento = () => import('@/app/views/publica/views/Consentimiento');


const publicaRoutes = [
  {
    path: "/publica",
    name: "Principal",
    component: PrincipalSaldo,
    meta: {
      auth: false
    }
  },
  {
    path: "/consentimiento/:token",
    name: "Consentimiento",
    component: Consentimiento,
    meta: {
      auth: false
    }
  },
];

export default publicaRoutes;
